import api from '../utils/api';

export interface DirectionsResponse {
  success: boolean;
  message: string;
  data: {
    originToPickup: {
      distance: { kilometers: string; miles: string; text: string; value: number };
      duration: { minutes: string; hours: string; text: string; value: number };
      polyline: string;
    };
    pickupToDrop: {
      distance: { kilometers: string; miles: string; text: string; value: number };
      duration: { minutes: string; hours: string; text: string; value: number };
      polyline: string;
    };
    summary: {
      totalDistance: { kilometers: string; miles: string };
      totalDuration: { minutes: string; hours: string };
    };
  };
}

export async function getDirections(params: {
  origin: string; // "lat,lng"
  pickup: string; // "lat,lng"
  drop: string; // "lat,lng"
}): Promise<DirectionsResponse> {
  const res = await api.post('/google-maps/directions', params);
  return res.data;
}

